/* eslint-disable */
export default {
  finalize() {
    var elem = document.querySelector('.fw__wall');
    var iso = new window.Isotope(elem, {
      layoutMode: 'masonryHorizontal',
      itemSelector: '.wall-item',
      masonryHorizontal: {
        gutter: 20,
      },
    }),
    scroll = $('.fw__wall-wrap'),
    scrollWidth = $('.fw__wall').outerWidth(),
    handle = $('.seekbar input[type="range"]'),
    progressbar = $('.seekbar div[role="progressbar"]');

    $('.fw__wall').addClass('is-showing-items');
    iso;

    handle
    .attr('max', scrollWidth)
    .on('input', function(){
      progressbar.css({'width' : ((this.value / scrollWidth) * 100) + '%'});
      progressbar.attr('aria-valuenow', this.value);
      scroll.animate({scrollLeft: this.value}, 0);
    });

    $(window).on('load', function(){
      $('.fw__wall-wrap').css({
        'padding-left': $('.fw__body').offset().left,
      });

      $('.fw__wall').css('padding-right', $('.fw__body').offset().left);
    })

    $('.fw__name-search').on('submit', function(e) {
      e.preventDefault();
      var val = $('.name-input').val(),
        wallItem = scroll.find('.wall-item:contains('+val+')'),
        posLeft = wallItem.offset().left,
        posScroll = posLeft - ($('.fw__wrap').outerWidth() / 2),
        posBar = posLeft - 100;

      if(val !== '') {
        scroll.animate({scrollLeft: '+=' + posScroll}, 'fast');
        progressbar.animate({'width' : '+=' + ((posBar / scrollWidth) * 100) + '%'}, 'fast');
        
        $('.wall-item').css('background-color', '#212121');
        wallItem.css('background-color', '#dd0506');
        return false;
      }
    });

    $.expr[':'].contains = $.expr.createPseudo(function(arg) {
      return function(elem) {
        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
      }
    })
  },
};

/* eslint-enable */
